// Fonction pour gérer le défilement en douceur au click sur l'ancre
jQuery(document).ready(function(){
  function smoothScroll(target, duration) {
    var targetElement = document.querySelector(target);
    if (!targetElement) return;

    var targetPosition = targetElement.offsetTop;
    var startPosition = window.pageYOffset;
    var distance = targetPosition - startPosition;
    var startTime = null;

    function animation(currentTime) {
      if (startTime === null) startTime = currentTime;
      var timeElapsed = currentTime - startTime;
      var ease = Math.easeInOutQuad(timeElapsed, 0, 1, duration);

      window.scrollTo(0, startPosition + distance * ease);

      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      }
    }

    // Fonction d'accélération de défilement
    Math.easeInOutQuad = function (t, b, c, d) {
      t /= d / 2;
      if (t < 1) return c / 2 * t * t + b;
      t--;
      return -c / 2 * (t * (t - 2) - 1) + b;
    };

    requestAnimationFrame(animation);
  }

  // Écouteurs d'événements pour les liens d'ancre avec la classe
  var anchorLinks = document.querySelectorAll('.anchors_js a[href^="#"]');
  anchorLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      var targetId = link.getAttribute('href');
      smoothScroll(targetId, 1000); // 1000ms (1 seconde) pour la durée du défilement
    });
  });
});